import { InjectionToken } from '@angular/core';
import { Config } from '@modeso/modeso-lib-core-fe';

export interface ModesoLocalizationConfig extends Config {
    serviceId: string;
}

export const ModesoLocalizationConfigService = new InjectionToken<ModesoLocalizationConfig>('Config');
